<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconHelpRound_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0M7.235 5.39a1.399 1.399 0 0 1 2.108 1.209c0 .328-.255.672-.738.993a4.2 4.2 0 0 1-.872.44l-.011.004a.7.7 0 1 0 .444 1.328L7.944 8.7l.222.664h.002l.002-.002.008-.002.024-.009.082-.03a5.632 5.632 0 0 0 1.099-.564c.567-.378 1.361-1.086 1.361-2.157a2.8 2.8 0 0 0-5.442-.932.7.7 0 1 0 1.322.464 1.4 1.4 0 0 1 .611-.743M8 10.8a.7.7 0 1 0 0 1.4h.007a.7.7 0 1 0 0-1.4z"
        clip-rule="evenodd"
    />
</svg>
